/**
 * 真太阳时＝当地平太阳时 + 真平太阳时差
 * 1，地球自传一周为一天。24小时乘以60分钟在除以360度，等于4分钟每度。所以每相差1经度就相差4分钟。一个时区为60分钟则相差15经度，就是15经度为1个时区。
 * 2，各地的平太阳时以北京时间相加减，如北京时间12:00时, 武汉地区的平太阳时为：12时00分-22.7分 = 12时00分-22分42秒 = 11时37分18秒。即为11时37分18秒。注意时间单位的换算。
 * 3，凡本表未列之地区，可按当地之经度推算平太阳时，其原则以东经120度为基准，每减少1度则减4分钟，每增加1度则加4分钟，如某地位于东经105度，105-120=-15度，-15度×4分钟=-60分钟，则当地的平太阳时用北京时间减去60分钟；又如某地位于东经130度，130-120=10度，10度×4分钟=40分钟，则当地的平太阳时用，北京时间加上40分钟，余类推。如果不能确定某地的经度，一个粗略的办法就是根据上表中所列的地区，找到其比较邻近的城市确定时差值。
 * 4，这里推算出来的时间乃是平太阳时，还须进一步推算出真太阳时才能论定时辰。
 * 5，出生地：昆明　经度：102度73分 出生钟表时间＝2000年1月1日0时0分 出生地方时间＝出生钟表时间－68分8秒 出生真太阳时＝出生地方时间－3分9秒
 * 6，实际出生时间＝1999年12月31日22时49分
 */

import momenttime, { MOMENT_TIME } from '../../momenttime'

/**
 * 一年356天，每天的偏差
 */
const SUN_DEVIATION = {
    '1\u670801\u65E5': '-3:9',
    '1\u670802\u65E5': '-3:38',
    '1\u670803\u65E5': '-4:6',
    '1\u670804\u65E5': '-4:33',
    '1\u670805\u65E5': '-5:1',
    '1\u670806\u65E5': '-5:27',
    '1\u670807\u65E5': '-5:54',
    '1\u670808\u65E5': '-6:20',
    '1\u670809\u65E5': '-6:45',
    '1\u670810\u65E5': '-7:10',
    '1\u670811\u65E5': '-7:35',
    '1\u670812\u65E5': '-7:59',
    '1\u670813\u65E5': '-8:22',
    '1\u670814\u65E5': '-8:45',
    '1\u670815\u65E5': '-9:7',
    '1\u670816\u65E5': '-9:28',
    '1\u670817\u65E5': '-9:49',
    '1\u670818\u65E5': '-10:9',
    '1\u670819\u65E5': '-10:28',
    '1\u670820\u65E5': '-10:47',
    '1\u670821\u65E5': '-11:5',
    '1\u670822\u65E5': '-11:22',
    '1\u670823\u65E5': '-11:38',
    '1\u670824\u65E5': '-11:54',
    '1\u670825\u65E5': '-12:8',
    '1\u670826\u65E5': '-12:22',
    '1\u670827\u65E5': '-12:35',
    '1\u670828\u65E5': '-12:59',
    '1\u670829\u65E5': '-13:10',
    '1\u670830\u65E5': '-13:19',
    '1\u670831\u65E5': '-13:37',
    '2\u670801\u65E5': '-13:44',
    '2\u670802\u65E5': '-13:50',
    '2\u670803\u65E5': '-13:56',
    '2\u670804\u65E5': '-14:1',
    '2\u670805\u65E5': '-14:5',
    '2\u670806\u65E5': '-14:9',
    '2\u670807\u65E5': '-14:11',
    '2\u670808\u65E5': '-14:13',
    '2\u670809\u65E5': '-14:14',
    '2\u670810\u65E5': '-14:15',
    '2\u670811\u65E5': '-14:14',
    '2\u670812\u65E5': '-14:13',
    '2\u670813\u65E5': '-14:11',
    '2\u670814\u65E5': '-14:8',
    '2\u670815\u65E5': '-14:5',
    '2\u670816\u65E5': '-14:1',
    '2\u670817\u65E5': '-13:56',
    '2\u670818\u65E5': '-13:51',
    '2\u670819\u65E5': '-13:44',
    '2\u670820\u65E5': '-13:38',
    '2\u670821\u65E5': '-13:30',
    '2\u670822\u65E5': '-13:22',
    '2\u670823\u65E5': '-13:13',
    '2\u670824\u65E5': '-11:4',
    '2\u670825\u65E5': '-12:54',
    '2\u670826\u65E5': '-12:43',
    '2\u670827\u65E5': '-12:32',
    '2\u670828\u65E5': '-12:21',
    '2\u670829\u65E5': '-12:8',
    '3\u670801\u65E5': '-11:56',
    '3\u670802\u65E5': '-11:43',
    '3\u670803\u65E5': '-11:29',
    '3\u670804\u65E5': '-11:15',
    '3\u670805\u65E5': '-11:1',
    '3\u670806\u65E5': '-10:47',
    '3\u670807\u65E5': '-10:32',
    '3\u670808\u65E5': '-10:16',
    '3\u670809\u65E5': '-10:1',
    '3\u670810\u65E5': '-9:45',
    '3\u670811\u65E5': '-9:28',
    '3\u670812\u65E5': '-9:12',
    '3\u670813\u65E5': '-8:55',
    '3\u670814\u65E5': '-8:38',
    '3\u670815\u65E5': '-8:21',
    '3\u670816\u65E5': '-8:4',
    '3\u670817\u65E5': '-7:46',
    '3\u670818\u65E5': '-7:29',
    '3\u670819\u65E5': '-7:11',
    '3\u670820\u65E5': '-6:53',
    '3\u670821\u65E5': '-6:35',
    '3\u670822\u65E5': '-6:17',
    '3\u670823\u65E5': '-5:58',
    '3\u670824\u65E5': '-5:40',
    '3\u670825\u65E5': '-5:22',
    '3\u670826\u65E5': '-5:4',
    '3\u670827\u65E5': '-4:45',
    '3\u670828\u65E5': '-4:27',
    '3\u670829\u65E5': '-4:9',
    '3\u670830\u65E5': '-3:51',
    '3\u670831\u65E5': '-3:33',
    '4\u670801\u65E5': '-3:16',
    '4\u670802\u65E5': '-2:58',
    '4\u670803\u65E5': '-2:41',
    '4\u670804\u65E5': '-2:24',
    '4\u670805\u65E5': '-2:7',
    '4\u670806\u65E5': '-1:50',
    '4\u670807\u65E5': '-1:33',
    '4\u670808\u65E5': '-1:17',
    '4\u670809\u65E5': '-1:1',
    '4\u670810\u65E5': '+0:46',
    '4\u670811\u65E5': '+0:30',
    '4\u670812\u65E5': '+0:16',
    '4\u670813\u65E5': '+0:1',
    '4\u670814\u65E5': '+0:13',
    '4\u670815\u65E5': '+0:27',
    '4\u670816\u65E5': '+0:41',
    '4\u670817\u65E5': '+0:54',
    '4\u670818\u65E5': '+1:6',
    '4\u670819\u65E5': '+1:19',
    '4\u670820\u65E5': '+1:31',
    '4\u670821\u65E5': '+1:42',
    '4\u670822\u65E5': '+1:53',
    '4\u670823\u65E5': '+2:4',
    '4\u670824\u65E5': '+2:14',
    '4\u670825\u65E5': '+2:23',
    '4\u670826\u65E5': '+2:33',
    '4\u670827\u65E5': '+2:41',
    '4\u670828\u65E5': '+2:49',
    '4\u670829\u65E5': '+2:57',
    '4\u670830\u65E5': '+3:4',
    '5\u670801\u65E5': '+1:10',
    '5\u670802\u65E5': '+3:16',
    '5\u670803\u65E5': '+3:21',
    '5\u670804\u65E5': '+3:26',
    '5\u670805\u65E5': '+3:30',
    '5\u670806\u65E5': '+3:37',
    '5\u670807\u65E5': '+3:36',
    '5\u670808\u65E5': '+3:39',
    '5\u670809\u65E5': '+3:40',
    '5\u670810\u65E5': '+3:42',
    '5\u670811\u65E5': '+3:42',
    '5\u670812\u65E5': '+3:42',
    '5\u670813\u65E5': '+3:42',
    '5\u670814\u65E5': '+3:41',
    '5\u670815\u65E5': '+3:39',
    '5\u670816\u65E5': '+3:37',
    '5\u670817\u65E5': '+3:34',
    '5\u670818\u65E5': '+3:31',
    '5\u670819\u65E5': '+3:27',
    '5\u670820\u65E5': '+3:23',
    '5\u670821\u65E5': '+3:18',
    '5\u670822\u65E5': '+3:13',
    '5\u670823\u65E5': '+3:7',
    '5\u670824\u65E5': '+3:1',
    '5\u670825\u65E5': '+2:54',
    '5\u670826\u65E5': '+2:47',
    '5\u670827\u65E5': '+2:39',
    '5\u670828\u65E5': '+2:31',
    '5\u670829\u65E5': '+2:22',
    '5\u670830\u65E5': '+2:13',
    '5\u670831\u65E5': '+2:4',
    '6\u670801\u65E5': '+1:54',
    '6\u670802\u65E5': '+1:44',
    '6\u670803\u65E5': '+1:34',
    '6\u670804\u65E5': '+1:23',
    '6\u670805\u65E5': '+1:12',
    '6\u670806\u65E5': '+1:0',
    '6\u670807\u65E5': '+0:48',
    '6\u670808\u65E5': '+0:36',
    '6\u670809\u65E5': '+0:24',
    '6\u670810\u65E5': '+0:12',
    '6\u670811\u65E5': '+0:1',
    '6\u670812\u65E5': '+0:14',
    '6\u670813\u65E5': '+0:39',
    '6\u670814\u65E5': '+0:52',
    '6\u670815\u65E5': '-1:5',
    '6\u670816\u65E5': '-1:18',
    '6\u670817\u65E5': '-1:31',
    '6\u670818\u65E5': '-1:45',
    '6\u670819\u65E5': '-1:57',
    '6\u670820\u65E5': '-2:10',
    '6\u670821\u65E5': '-2:23',
    '6\u670822\u65E5': '-2:36',
    '6\u670823\u65E5': '-2:48',
    '6\u670824\u65E5': '-3:1',
    '6\u670825\u65E5': '-3:13',
    '6\u670826\u65E5': '-3:25',
    '6\u670827\u65E5': '-3:37',
    '6\u670828\u65E5': '-3:49',
    '6\u670829\u65E5': '-4:0',
    '6\u670830\u65E5': '-4:11',
    '7\u670801\u65E5': '-4:22',
    '7\u670802\u65E5': '-4:33',
    '7\u670803\u65E5': '-4:43',
    '7\u670804\u65E5': '-4:53',
    '7\u670805\u65E5': '-5:2',
    '7\u670806\u65E5': '-5:11',
    '7\u670807\u65E5': '-5:20',
    '7\u670808\u65E5': '-5:28',
    '7\u670809\u65E5': '-5:36',
    '7\u670810\u65E5': '-5:43',
    '7\u670811\u65E5': '-5:50',
    '7\u670812\u65E5': '-5:56',
    '7\u670813\u65E5': '-6:2',
    '7\u670814\u65E5': '-6:8',
    '7\u670815\u65E5': '-6:12',
    '7\u670816\u65E5': '-6:16',
    '7\u670817\u65E5': '-6:20',
    '7\u670818\u65E5': '-6:23',
    '7\u670819\u65E5': '-6:25',
    '7\u670820\u65E5': '-6:27',
    '7\u670821\u65E5': '-6:29',
    '7\u670822\u65E5': '-6:29',
    '7\u670823\u65E5': '-6:29',
    '7\u670824\u65E5': '-6:29',
    '7\u670825\u65E5': '-6:28',
    '7\u670826\u65E5': '-6:26',
    '7\u670827\u65E5': '-6:24',
    '7\u670828\u65E5': '-6:21',
    '7\u670829\u65E5': '-6:17',
    '7\u670830\u65E5': '-6:13',
    '7\u670831\u65E5': '-6:8',
    '8\u670801\u65E5': '-6:3',
    '8\u670802\u65E5': '-5:57',
    '8\u670803\u65E5': '-5:51',
    '8\u670804\u65E5': '-5:44',
    '8\u670805\u65E5': '-5:36',
    '8\u670806\u65E5': '-5:28',
    '8\u670807\u65E5': '-5:19',
    '8\u670808\u65E5': '-5:10',
    '8\u670809\u65E5': '-5:0',
    '8\u670810\u65E5': '-4:50',
    '8\u670811\u65E5': '-4:39',
    '8\u670812\u65E5': '-4:27',
    '8\u670813\u65E5': '-4:15',
    '8\u670814\u65E5': '-4:2',
    '8\u670815\u65E5': '-3:49',
    '8\u670816\u65E5': '-3:36',
    '8\u670817\u65E5': '-3:21',
    '8\u670818\u65E5': '-3:7',
    '8\u670819\u65E5': '-2:51',
    '8\u670820\u65E5': '-2:36',
    '8\u670821\u65E5': '-2:20',
    '8\u670822\u65E5': '-2:3',
    '8\u670823\u65E5': '-1:47',
    '8\u670824\u65E5': '-1:29',
    '8\u670825\u65E5': '-1:12',
    '8\u670826\u65E5': '+0:54',
    '8\u670827\u65E5': '+0:35',
    '8\u670828\u65E5': '+0:17',
    '8\u670829\u65E5': '+0:2',
    '8\u670830\u65E5': '+0:21',
    '8\u670831\u65E5': '+0:41',
    '9\u670801\u65E5': '+1:0',
    '9\u670802\u65E5': '+1:20',
    '9\u670803\u65E5': '+1:40',
    '9\u670804\u65E5': '+2:1',
    '9\u670805\u65E5': '+2:21',
    '9\u670806\u65E5': '+2:42',
    '9\u670807\u65E5': '+3:3',
    '9\u670808\u65E5': '+3:3',
    '9\u670809\u65E5': '+3:24',
    '9\u670810\u65E5': '+3:45',
    '9\u670811\u65E5': '+4:6',
    '9\u670812\u65E5': '+4:27',
    '9\u670813\u65E5': '+4:48',
    '9\u670814\u65E5': '+5:10',
    '9\u670815\u65E5': '+5:31',
    '9\u670816\u65E5': '+5:53',
    '9\u670817\u65E5': '+6:14',
    '9\u670818\u65E5': '+6:35',
    '9\u670819\u65E5': '+6:57',
    '9\u670820\u65E5': '+7:18',
    '9\u670821\u65E5': '+7:39',
    '9\u670822\u65E5': '+8:0',
    '9\u670823\u65E5': '+8:21',
    '9\u670824\u65E5': '+8:42',
    '9\u670825\u65E5': '+9:2',
    '9\u670826\u65E5': '+9:22',
    '9\u670827\u65E5': '+9:42',
    '9\u670828\u65E5': '+10:2',
    '9\u670829\u65E5': '+10:21',
    '9\u670830\u65E5': '+10:40',
    '10\u670801\u65E5': '+10:59',
    '10\u670802\u65E5': '+11:18',
    '10\u670803\u65E5': '+11:36',
    '10\u670804\u65E5': '+11:36',
    '10\u670805\u65E5': '+11:53',
    '10\u670806\u65E5': '+12:11',
    '10\u670807\u65E5': '+12:28',
    '10\u670808\u65E5': '+12:44',
    '10\u670809\u65E5': '+12:60',
    '10\u670810\u65E5': '+13:16',
    '10\u670811\u65E5': '+13:16',
    '10\u670812\u65E5': '+13:31',
    '10\u670813\u65E5': '+13:45',
    '10\u670814\u65E5': '+13:59',
    '10\u670815\u65E5': '+14:13',
    '10\u670816\u65E5': '+14:26',
    '10\u670817\u65E5': '+14:38',
    '10\u670818\u65E5': '+14:50',
    '10\u670819\u65E5': '+15:1',
    '10\u670820\u65E5': '+15:12',
    '10\u670821\u65E5': '+11:21',
    '10\u670822\u65E5': '+15:31',
    '10\u670823\u65E5': '+15:40',
    '10\u670824\u65E5': '+15:48',
    '10\u670825\u65E5': '+15:55',
    '10\u670826\u65E5': '+16:1',
    '10\u670827\u65E5': '+16:7',
    '10\u670828\u65E5': '+16:12',
    '10\u670829\u65E5': '+16:16',
    '10\u670830\u65E5': '+16:20',
    '10\u670831\u65E5': '+16:22',
    '11\u670801\u65E5': '+16:24',
    '11\u670802\u65E5': '+16:25',
    '11\u670803\u65E5': '+16:25',
    '11\u670804\u65E5': '+16:24',
    '11\u670805\u65E5': '+16:23',
    '11\u670806\u65E5': '+16:21',
    '11\u670807\u65E5': '+16:17',
    '11\u670808\u65E5': '+16:13',
    '11\u670809\u65E5': '+16:9',
    '11\u670810\u65E5': '+16:3',
    '11\u670811\u65E5': '+15:56',
    '11\u670812\u65E5': '+15:49',
    '11\u670813\u65E5': '+15:41',
    '11\u670814\u65E5': '+15:32',
    '11\u670815\u65E5': '+15:22',
    '11\u670816\u65E5': '+15:11',
    '11\u670817\u65E5': '+14:60',
    '11\u670818\u65E5': '+14:47',
    '11\u670819\u65E5': '+14:34',
    '11\u670820\u65E5': '+14:20',
    '11\u670821\u65E5': '+14:6',
    '11\u670822\u65E5': '+13:50',
    '11\u670823\u65E5': '+13:34',
    '11\u670824\u65E5': '+13:17',
    '11\u670825\u65E5': '+12:59',
    '11\u670826\u65E5': '+12:40',
    '11\u670827\u65E5': '+12:21',
    '11\u670828\u65E5': '+12:1',
    '11\u670829\u65E5': '+11:40',
    '11\u670830\u65E5': '+11:18',
    '12\u670801\u65E5': '+10:56',
    '12\u670802\u65E5': '+10:33',
    '12\u670803\u65E5': '+10:9',
    '12\u670804\u65E5': '+9:45',
    '12\u670805\u65E5': '+9:21',
    '12\u670806\u65E5': '+8:55',
    '12\u670807\u65E5': '+8:29',
    '12\u670808\u65E5': '+8:3',
    '12\u670809\u65E5': '+7:36',
    '12\u670810\u65E5': '+7:9',
    '12\u670811\u65E5': '+6:42',
    '12\u670812\u65E5': '+6:14',
    '12\u670813\u65E5': '+5:46',
    '12\u670814\u65E5': '+5:17',
    '12\u670815\u65E5': '+4:48',
    '12\u670816\u65E5': '+4:19',
    '12\u670817\u65E5': '+3:50',
    '12\u670818\u65E5': '+3:21',
    '12\u670819\u65E5': '+2:51',
    '12\u670820\u65E5': '+2:22',
    '12\u670821\u65E5': '+1:52',
    '12\u670822\u65E5': '+1:22',
    '12\u670823\u65E5': '+0:52',
    '12\u670824\u65E5': '+0:23',
    '12\u670825\u65E5': '+0:7',
    '12\u670826\u65E5': '+0:37',
    '12\u670827\u65E5': '-1:6',
    '12\u670828\u65E5': '-1:36',
    '12\u670829\u65E5': '-2:5',
    '12\u670830\u65E5': '-2:34',
    '12\u670831\u65E5': '-3:3',

}

var REAL_SUN_TIME = {

    /**
     * 主函数：获取真太阳时
     * @param {日期时间戳}} myTime 
     * @param {省市区的经度}} latitude 
     */
    getRealSunTime(myTime, latitude) {
        // 输入值
        console.log('经度', latitude);
        console.log('当前输入时间', MOMENT_TIME.getFormateTimeByTimeStamp(myTime * 1000));
        
        // 1、根据经纬度来算本地时间
        var detTime = ((120 - latitude) * 4 * 60 * 1000);
        var localTime = parseInt(myTime * 1000 - detTime);
        console.log('经度时间差', detTime)
        console.log('出生地方时间', MOMENT_TIME.getFormateTimeByTimeStamp(localTime));
        
        // 2、根据几月几日获取出生地方时间 与 真太阳时之间的时间差
        var timeArr = MOMENT_TIME.getTimeArrayByTimeStamp(localTime);
        var timeStr = timeArr[1] + '月' + (timeArr[2] < 10 ? '0' + timeArr[2] : timeArr[2]) + '日';
        console.log('出生地方时间<->真太阳时 时间差', timeStr, SUN_DEVIATION[timeStr])
        
        // 3、根据时间差获取真太阳时
        var realSunTime = this.getLocalTime(SUN_DEVIATION[timeStr], localTime);
        console.log('真太阳时间', realSunTime, MOMENT_TIME.getFormateTimeByTimeStamp(realSunTime));
        
        return parseInt(realSunTime);
    },

    /**
     * 计算时间差
     * @param {时差字符串} devStr 
     * @param {出生地方时间} localTime 
     */
    getLocalTime(devStr, localTime) {
        var devArr = devStr.split(':');
        var deviation, resultTime;
        
        // 判断符号：正号或负号
        var isNegative = devStr.indexOf('-') != -1;
        
        if(devArr.length == 3) {
            //地区时间差 存在小时 HH:MM:SS
            // 去掉符号后计算
            var hourStr = devArr[0].replace(/[+-]/g, '');
            deviation = 3600 * parseInt(hourStr) + 60 * parseInt(devArr[1]) + parseInt(devArr[2]);
        }else{
            // 2元素格式: 分:秒 格式（如 "-5:43" 表示 -5分43秒）
            // 去掉符号后计算
            var firstPart = devArr[0].replace(/[+-]/g, '');
            deviation = 60 * parseInt(firstPart) + parseInt(devArr[1]);
        }

        // 应用符号：负号表示减去时间，正号表示加上时间
        if(isNegative){
            deviation = -deviation;
        }

        // 毫秒数
        var deviationMs = deviation * 1000;
        resultTime = localTime + deviationMs;
        
        // console.log("getLocalTime----", devStr, devArr, localTime)
        // console.log(localTime, deviation, resultTime)
        return resultTime;
    }

}

export {
    REAL_SUN_TIME
}